import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { canNavigate } from "./utils";
var useCallback = React.useCallback;
export var DefaultLinkBehavior = /*#__PURE__*/React.forwardRef(function DefaultLinkBehavior(_ref, ref) {
  var forceRefresh = _ref.forceRefresh,
      navigate = _ref.navigate,
      onBeforeNavigate = _ref.onBeforeNavigate,
      props = _objectWithoutProperties(_ref, ["forceRefresh", "navigate", "onBeforeNavigate"]);

  var download = props.download,
      href = props.href,
      onClick = props.onClick,
      target = props.target;
  var handleClick = useCallback(function (event) {
    if (href && navigate && canNavigate(event, {
      forceRefresh: forceRefresh,
      download: download,
      href: href,
      target: target
    })) {
      onBeforeNavigate && onBeforeNavigate(event);
      navigate(event, href);
    }

    onClick && onClick(event);
  }, [download, forceRefresh, href, navigate, onBeforeNavigate, onClick, target]);

  if (href) {
    delete props.type;
  } else {
    props.type = props.type || 'button';
    delete props.href;
  } // Prevent usage of unsafe target='_blank' by setting rel="noopener noreferrer".
  // This could be more nuanced (e.g. only external links) in the future.
  // https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-target-blank.md


  var rel = target === '_blank' ? 'noopener noreferrer' : props.rel;
  var className = classNames('UnstyledLink', props.className);
  var Element = href ? 'a' : 'button';
  return /*#__PURE__*/React.createElement(Element, _extends({}, props, {
    className: className,
    onClick: handleClick,
    rel: rel,
    ref: ref
  }));
});
DefaultLinkBehavior.displayName = 'DefaultLinkBehavior';